module.exports = __webpack_public_path__ + "static/media/ZCLO.e194b125.pdf";